if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

        this.modalToggle = this.querySelector('.quick-add-modal__content');

        let isDragging = false;
        let startY;
        let currentY;
        
        this.modalToggle.addEventListener('touchstart', (e) => {
            isDragging = true;
            startY = e.touches[0].clientY;
            this.modalToggle.classList.add('dragging');
        });
        
        document.addEventListener('touchmove', (e) => {
            if (!isDragging) return;
        
            currentY = e.touches[0].clientY - startY;
            if (currentY < 0) {
              return false;
            }
            this.modalToggle.style.transform = `translate(0, ${currentY}px)`;
        });
        
        document.addEventListener('touchend', () => {
            if (!isDragging) return;
        
            isDragging = false;
            this.modalToggle.classList.remove('dragging');

            if (currentY > 100) { 
                this.modalToggle.style.transition = 'transform 0.5s ease';
                this.modalToggle.style.transform = 'translate(0, 100%)';
                super.hide();
                this.modalToggle.style.transition = '';
                this.modalToggle.style.transform = '';
            } else {
              
                this.modalToggle.style.transition = 'transform 0.5s ease';
                this.modalToggle.style.transform = 'translate(0, 0)';
              
            }
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        

        window.tempInputs = []; //global variable for code disable default choise variants
        if (preventFocus) this.openedBy = null;
         this.querySelector('.quick-add-modal__content').style.minHeight = this.modalContent.offsetHeight + 'px';
        super.hide();
       
        this.modalContent.innerHTML = '';
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            const sliderProductQuick = new Swiper('.quick-add-modal .slider--main', {
              slidesPerView: 1,
              spaceBetween: 0,
              watchOverflow: false,
              resistanceRatio: true,
              breakpoints: {
                320: {
                  slidesPerView: 5.5,
                  spaceBetween: 0
                },
                750: {
                  slidesPerView: 1.15,
                  spaceBetween: 5,
                }
              },
               on: {
                  touchMove: function (swiper) {
                    console.log(123213123213213);
                      const translate = swiper.getTranslate();
                      const maxTranslate = swiper.width - swiper.slides[0].offsetWidth;
          
                      if (translate > 0) {
                          swiper.setTranslate(0);
                      } else if (translate < -maxTranslate) {
                          swiper.setTranslate(-maxTranslate);
                      }
                  }
              }
            });

            //init ajax product recomendations 
           // let complementary = this.querySelector('product-recommendations');
           //  this.getComplementaryProducts(complementary);

            // let fieldsSets = this.querySelectorAll('quick-add-modal variant-selects [type="radio"][value="default"]');
            // fieldsSets.forEach(elem => {
            //   elem.checked = true;
            //   elem.addAttribute('checked');
            // });
            
            /*
            * code for add to cart in quick mobile popup
            */
            // let butonAtttibutes = this.querySelectorAll('quick-add-modal variant-selects [type="radio"]');
            // let $this = this;
            // console.log(1234567);
            // butonAtttibutes.forEach(elem => {
            //   elem.addEventListener('change', function(e) {
                // e.preventDefault();
                // console.log(elem);
                // let checkedInputs = $this.querySelectorAll('input[type="radio"]:checked');
                // let fieldsSets = $this.querySelectorAll('fieldset');
                
                // if ( checkedInputs.length === fieldsSets.length ) {
                //   let btn = $this.querySelector('product-form');
                //   btn.onSubmitHandlerCustom();
                // } 
                
            //   });
            // });

          })
          .finally(() => {
            
            
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');

            super.show(opener);
            
            
          });
      }

      getComplementaryProducts(complementary) {
        let $this = complementary;
         fetch(`${$this.dataset.url}&product_id=${$this.dataset.productId}&section_id=template--17346969665714__main`)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
    
            if (recommendations?.innerHTML.trim().length) {
              $this.innerHTML = recommendations.innerHTML;

              //init select2 plugin
              // let element = $this.querySelectorAll('select.select__select');
              // element.forEach( item => {
              //   new Choices(item);
              // });
              
            }
    
            if (!$this.querySelector('slideshow-component') && $this.classList.contains('complementary-products')) {
              $this.remove();
            }
    
            if (html.querySelector('.grid__item') ) {
              $this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
